import { useEffect, useState } from 'react';
import { apiFetch } from '../lib/api';

// Module-level cache — every AiAssistButton instance on a page (a ticket
// form can have several textareas) shares one /ai/status call instead of
// each firing its own on mount. Re-fetched only on a fresh page load.
let _statusPromise = null;
export function resetAiStatusCache() {
  _statusPromise = null;
}
function fetchStatus() {
  if (!_statusPromise) {
    _statusPromise = apiFetch('/ai/status')
      .then((r) => !!r.data?.enabled)
      .catch(() => false);
  }
  return _statusPromise;
}

// Whether the AI-assist affordance should render at all for the current
// user — false while loading, so nothing flashes in then disappears.
export default function useAiEnabled() {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetchStatus().then((value) => {
      if (!cancelled) setEnabled(value);
    });
    return () => { cancelled = true; };
  }, []);

  return enabled;
}
